/* WattWheelz V60.4 — measure the real stacked mobile header instead of using a stale 120px offset. */
(function(){
  const mq=window.matchMedia('(max-width: 749px)');
  const root=document.documentElement;
  let menu=null,toggle=null,header=null,raf=0;
  function measure(){
    if(!mq.matches){root.style.removeProperty('--ww-mobile-menu-top');return;}
    header=header||document.querySelector('[data-ww-header]');
    if(!header)return;
    const rect=header.getBoundingClientRect();
    const bottom=Math.max(0,Math.min(window.innerHeight,Math.round(rect.bottom)));
    if(bottom>0)root.style.setProperty('--ww-mobile-menu-top',bottom+'px');
  }
  function sync(){
    menu=menu||document.querySelector('[data-ww-mobile-menu]');
    toggle=toggle||document.querySelector('[data-ww-mobile-toggle]');
    if(!menu)return;
    const open=menu.classList.contains('is-open');
    document.body.classList.toggle('ww-mobile-menu-open',open&&mq.matches);
    menu.setAttribute('aria-hidden',String(!open));
    if(toggle)toggle.setAttribute('aria-expanded',String(open));
    if(open){cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>{measure();menu.scrollTop=0;});}
  }
  function ready(){
    menu=document.querySelector('[data-ww-mobile-menu]');
    toggle=document.querySelector('[data-ww-mobile-toggle]');
    header=document.querySelector('[data-ww-header]');
    measure();sync();
    if(menu){new MutationObserver(sync).observe(menu,{attributes:true,attributeFilter:['class']});}
    if(toggle)toggle.addEventListener('click',()=>requestAnimationFrame(sync));
    window.addEventListener('resize',()=>requestAnimationFrame(measure),{passive:true});
    window.addEventListener('orientationchange',()=>setTimeout(measure,120));
    window.addEventListener('scroll',()=>{if(!menu?.classList.contains('is-open'))requestAnimationFrame(measure)},{passive:true});
    document.addEventListener('shopify:section:load',()=>setTimeout(()=>{header=null;measure();sync();},60));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();
